import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
gsap.registerPlugin(ScrollTrigger, SplitText)

import Swiper from "swiper"
import { Navigation, Autoplay, FreeMode, EffectFade, Pagination } from "swiper/modules"

import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/free-mode"
import "swiper/css/effect-fade"

export const swiper = () => {
	gallery()
	galleryZoom()
	roomsPreview()
	roomsImages()
	offers()
	timeline()
	footer()
}

const gallery = () => {

	let els = document.querySelectorAll('[data-swiper="gallery"]')

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Navigation],
			slidesPerView: 'auto',
			grabCursor: true,
			centeredSlides: true,
			loop: true,
			speed: 1200,
			navigation: {
				prevEl: el.querySelector('[data-button="previous"]'),
				nextEl: el.querySelector('[data-button="next"]'),
			},
			on: {
				slideChange: function () {
					el.querySelector('[data-number="current"]').textContent = this.realIndex + 1;
				}
			}
		})
	})
}

const galleryZoom = () => {

	let els = document.querySelectorAll('[data-swiper="gallery-zoom"]')

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Navigation, Autoplay],
			slidesPerView: 'auto',
			grabCursor: true,
			centeredSlides: false,
			freeMode: true,
			loop: true,
			speed: 15000,
			mousewheel: {
				invert: false,
				sensitivity: 1,
				forceToAxis: true,
			},
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
			},
		})
	})
}

const roomsPreview = () => {

	let el = document.querySelector('[data-swiper="rooms"]'),
		animations = []

	if (!el || window.innerWidth < 782) return false

	let carousel = new Swiper(el, {
		modules: [Navigation, EffectFade],
		// loop: true,
		slidesPerView: 1.25,
		spaceBetween: 24,
		freeMode: true,
		effect: 'fade',
		allowTouchMove: false,
		noSwiping: true,
		breakpoints: {
			782: {
				freeMode: false,
				slidesPerView: 1,
				effect: 'fade',
			},
		},
	})

	let tl = gsap.timeline({
		scrollTrigger: {
			trigger: el,
			start: 'center center',
			end: '+=2000',
			pin: true,
			scrub: true,
			// markers: true,
			onUpdate: self => {
				let progress = self.progress,
					totalIntervals = carousel.slides.length,
					intervalSize = 1 / totalIntervals,
					currentInterval = Math.floor(progress / intervalSize)
				if (currentInterval !== self.lastInterval) {
					carousel.slideTo(currentInterval)
					self.lastInterval = currentInterval
				}
			}
		},
	})

	carousel.slides.forEach((slide, i) => {

		let bar = slide.querySelector('[data-el="progress"]'),
			el = slide.querySelector('[data-el="heading"]')

		if (!el) return

		tl.fromTo(bar, {
			scaleX: 0,
		}, {
			scaleX: 1,
			ease: 'none',
		})

		let split = new SplitText(el, { type: 'lines, words', linesClass: 'line', wordsClass: 'word' })

		animations[i] = gsap.fromTo(split.words, {
			y: '115%',
			opacity: 1,
			rotate: "4deg",
		}, {
			y: 0,
			opacity: 1,
			rotate: "0deg",
			stagger: 0.1,
			duration: 1.2,
			delay: 0,
			paused: true,
			ease: 'power2.out',
		})
	})

	carousel.on('slideChange', slide => {
		animations[slide.activeIndex].restart()
		animations[slide.activeIndex].play()
	})

	ScrollTrigger.create({
		trigger: el,
		start: 'top 70%',
		once: true,
		// markers: true,
		onEnter: () => {
			el.classList.add('swiper-in-viewport')
			animations[0].restart()
			animations[0].play()
		},
	})
}

const roomsImages = () => {

	let els = document.querySelectorAll('[data-swiper="rooms-images"]')

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Navigation],
			slidesPerView: 'auto',
			grabCursor: true,
			loop: false,
			speed: 1200,
			navigation: {
				prevEl: el.querySelector('[data-button="previous"]'),
				nextEl: el.querySelector('[data-button="next"]'),
			},
			on: {
				slideChange: function () {
					el.querySelector('[data-number="current"]').textContent = this.realIndex + 1;
				}
			}
		})
	})
}

const offers = () => {

	let els = document.querySelectorAll('[data-swiper="offers"]')

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Navigation, FreeMode],
			slidesPerView: 'auto',
			freeMode: true,
			grabCursor: true,
			navigation: {
				prevEl: el.parentElement.querySelector('[data-button="previous"]'),
				nextEl: el.parentElement.querySelector('[data-button="next"]'),
			},
		})
	})
}

const timeline = () => {

	let els = document.querySelectorAll('[data-swiper="timeline"]')

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Navigation, Pagination],
			grabCursor: true,
			spaceBetween: 24,
			speed: 900,
			navigation: {
				prevEl: el.parentElement.querySelector('[data-button="previous"]'),
				nextEl: el.parentElement.querySelector('[data-button="next"]'),
			},
			pagination: {
				el: el.parentElement.querySelector('.swiper-pagination'),
				clickable: true,
				renderBullet: (i, className) => {
					let slide = el.querySelectorAll('.swiper-slide')[i]
					return `<span class="${className}"><span class="year">${slide.dataset.year}</span></span>`
				}
			},
		})
	})
}

const footer = () => {

	let els = document.querySelectorAll('[data-swiper="footer-logos"]')

	if (!els.length) return false

	els.forEach(el => {
		new Swiper(el, {
			modules: [Autoplay],
			slidesPerView: 'auto',
			centeredSlides: true,
			grabCursor: true,
			loop: true,
			speed: 6000,
			autoplay: {
				delay: 0,
			},
			breakpoints: {
			},
		})
	})
}

export default () => { }